import { render, staticRenderFns } from "./address-form.vue?vue&type=template&id=c47af464&lang=pug"
import script from "./address-form.vue?vue&type=script&lang=ts"
export * from "./address-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports